import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { UserModel } from '@models/user.model';
import { RefundsListRequest } from '@models/refundsListRequest.model';
import { Refund } from '@models/refund.model';

@Injectable({
  providedIn: 'root',
})
export class RefundService {
  public userToken: any;
  private urlApi: string;
  public tokenAlt: string;
  public identity: UserModel;

  constructor(private http: HttpClient) {
    this.urlApi = environment.urlApi;
    this.readToken();
    this.readTokenAlt();
    this.getIdentity();
  }

  readToken() {
    if (sessionStorage.getItem('tokenCF')) {
      this.userToken = sessionStorage.getItem('tokenCF');
    } else {
      this.userToken = '';
    }
    return this.userToken;
  }

  readTokenAlt() {
    if (sessionStorage.getItem('tokenALT')) {
      this.tokenAlt = sessionStorage.getItem('tokenALT');
    } else {
      this.tokenAlt = '';
    }
    return this.tokenAlt;
  }

  getIdentity() {
    return (this.identity = UserModel.fromResponse(
      JSON.parse(sessionStorage.getItem('user'))
    ));
  }

  getRefunds(refundsListRequest: RefundsListRequest) {
    refundsListRequest.documentNumber = this.identity.userInfo.document;
    refundsListRequest.documentType = this.identity.userInfo.documentType;
    const headers = new HttpHeaders().set('token', environment.postgres ? this.tokenAlt : this.userToken);
    const options = {
      params: RefundsListRequest.toRequest(refundsListRequest),
      headers,
    };
    const url = `${this.urlApi}/pr_reintegros${environment.postgres ? '' : '_v3'}`;

    return this.http.get(url, options).pipe(
      map((resp: any) => {
        const refundsResponse = Refund.fromResponse(resp);
        const refundsList: Refund[] = refundsResponse.refunds;
        const totalPages = refundsResponse.totalPages;
   
        return {
          refundsList,
          totalPages,
        };
      })
    );
  }

  exportRefundsResult(refundsListRequest: RefundsListRequest) {
    refundsListRequest.documentNumber = this.identity.userInfo.document;
    refundsListRequest.documentType = this.identity.userInfo.documentType;
    const headers = new HttpHeaders().set('token', environment.postgres ? this.tokenAlt : this.userToken);
    const options = {
      params: RefundsListRequest.toRequest(refundsListRequest),
      headers,
    };

    return this.http.get(`${this.urlApi}/pr_exportar_reintegros${environment.postgres ? '' : '_v3'}`, {
      headers: options.headers,
      params: options.params,
      responseType: 'blob',
    });
  }
}
